<template>
  <div class="center-statistics">
    <div class="center-statistics__content">
      <div v-for="(item, index) in statList" :key="index" class="center-statistics__item">
        <img :src="item.icon" :alt="item.label" class="center-statistics__icon" />
        <div class="center-statistics__info">
          <span class="center-statistics__label">{{ item.label }}</span>
          <span class="center-statistics__value">{{ statData[item.key] }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, computed, onMounted } from 'vue'
import { useStore } from 'vuex'

export default {
  name: 'CenterStatisticsComponent',
  setup() {
    const store = useStore()
    const statData = reactive({
      projectTotal: 0,
      deviceTotal: 0,
      userTotal: 0,
      completeOrderTotal: 0
    })

    const statList = computed(() => [
      {
        label: '服务客户',
        key: 'projectTotal',
        icon: require('@/assets/image/homeIndex/服务客户.png')
      },
      {
        label: '运维设备',
        key: 'deviceTotal',
        icon: require('@/assets/image/homeIndex/运维设备.png')
      },
      {
        label: '运维人员',
        key: 'userTotal',
        icon: require('@/assets/image/homeIndex/运维人员.png')
      },
      {
        label: '完成工单',
        key: 'completeOrderTotal',
        icon: require('@/assets/image/homeIndex/完成工单.png')
      }
    ])

    const fetchData = async () => {
      try {
        const res = await store.dispatch('fetchProjectTotalStatistics')
        if (res && res.data) {
          Object.assign(statData, res.data)
        }
      } catch (e) {
        console.error('首页统计数据获取失败', e)
      }
    }

    // 供父组件调用的定时刷新方法
    const refreshData = () => {
      fetchData()
    }

    onMounted(() => {
      fetchData()
    })

    return {
      statData,
      statList,
      refreshData
    }
  }
}
</script>

<style lang="scss" scoped>
.center-statistics {
  width: 100%;
  padding: 0 50px;
  box-sizing: border-box;

  &__header {
    margin-bottom: 24px;
    text-align: center;
  }

  &__title {
    font-size: 20px;
    font-weight: bold;
    color: #fff;
    letter-spacing: 2px;
  }

  &__content {
    display: flex;
    justify-content: space-around;
    align-items: center;
    gap: 24px;
  }

  &__item {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex: 1;
    gap: 6px;
  }

  &__icon {
    width: 53px;
    height: 56px;
    object-fit: contain;
    flex-shrink: 0;
  }

  &__info {
    display: flex;
    flex-direction: column;
  }

  &__label {
    font-size: 14px;
    color: #FFF;
    letter-spacing: 1px;
  }

  &__value {
    font-family: 'OPPOSans-B';
    font-size: 24px;
    background: linear-gradient(180deg, #ffffff 40%, #00ffff 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    filter: drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.25));
  }
}
</style>
